export const isEventProp = (propName) => {
    return propName.indexOf('on') === 0 && propName[2] === propName[2].toUpperCase();
};
export const normalizeEventPropName = (propName) => {
    return `on${propName[2].toUpperCase()}${propName.substring(3)}`;
};
